import { List } from '@mui/material';
import { HistoryListItem } from '../../HistoryPanel/HistoryListView/HistoryListItem';
import { User } from '../types';

type HistoryListViewProps = {
  data: HistoryLogEntryResponse[],
  titleEditor: string,
}

export const HistoryListView = ({
  data,
  titleEditor,
}: HistoryListViewProps):JSX.Element => {
  const getDisplayName = (historyItem: HistoryLogEntryResponse):User => {
    if (historyItem?.user.firstName) {
      return {
        firstName: historyItem.user.firstName,
        lastName: historyItem.user.lastName || '',
      };
    }

    return {
      firstName: historyItem?.user.id,
      lastName: '',
    };
  };

  return (
    <List>
      {data.map((historyItem: HistoryLogEntryResponse) => {
        const user = getDisplayName(historyItem);

        return (
          <HistoryListItem
            key={ historyItem.id }
            createdAt={ historyItem.createdAt }
            userFirstName={ user.firstName }
            userLastName={ user.lastName }
            data={ historyItem.data }
            userAvatarUrl=""
            titleEditor={ titleEditor }
            actionType={ historyItem?.actionType }
          />
        );
      })}

    </List>
  );
};
